import {
  getChannelStepLabel,
  getStepTimestamp,
} from "@/shared/utils/helperFunctions";
import { CHANNEL_STEPS } from "@/shared/utils/utils";
import { Tooltip } from "@heroui/react";

/** Only steps with a real timestamp use brand/success; the next step stays gray until it fires. */
export default function StepIndicator({ data, color = "brand", channel }) {
  const steps = CHANNEL_STEPS[channel] || [];

  const isStepDone = (stepDef) => Boolean(getStepTimestamp(data, stepDef.key));

  return (
    <div className="flex items-center">
      {steps.map((step, index) => {
        const done = isStepDone(step);
        const Icon = step.icon;
        const segmentAfterDone = isStepDone(steps[index]);

        return (
          <div key={step.key} className="flex items-center">
            <Tooltip
              content={getChannelStepLabel(step, data)}
              placement="top"
              className="bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 font-medium text-xs shadow-md border border-gray-200 dark:border-gray-700 px-2.5 py-1 rounded-lg"
            >
              <div
                className={`w-5 h-5 rounded-full flex items-center justify-center text-white ${
                  done
                    ? color === "brand"
                      ? "bg-secondary"
                      : "bg-success-500"
                    : "bg-gray-300"
                }`}
              >
                <Icon size={14} />
              </div>
            </Tooltip>

            {index < steps.length - 1 && (
              <div
                className={`w-2 h-[1px] ${
                  segmentAfterDone
                    ? color === "brand"
                      ? "bg-secondary"
                      : "bg-success-500"
                    : "bg-gray-300"
                }`}
              />
            )}
          </div>
        );
      })}
    </div>
  );
}
